<cohrex-badge [color]="color" [isPill]="true" [small]="small">
  <ng-content></ng-content>
</cohrex-badge>
